/**
 * 任务管理
 * **/

const logApi = {
  //获取列表
  getList: '/SysLog/GetList',
}

export default logApi
